<template>
  <div id="eatup">
    <div id="jumper">
    </div>
    <div>
      <div id="logo">
      </div>
      <div id="text">
        Comming Soon!
      </div>
    </div>
    <div id="crawler">
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#eatup {
  position: relative;
  width: 1440px;
  height: 3883px;

  background: #FFA800;
}
#text {
  position: absolute;
  width: 575px;
  height: 94px;
  left: 432px;
  top: 651px;

  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 80px;
  line-height: 94px;
}
#jumper {
  position: absolute;
  width: 217px;
  height: 217px;
  left: 29px;
  top: 131px;
  background: url(/images/JumperColor.svg);
}
#logo {
  position: absolute;
  width: 320px;
  height: 445px;
  left: 560px;
  top: 131px;
  background:url(/images/dyr_logo.png);
}

#crawler {
  position: absolute;
  width: 356px;
  height: 279px;
  left: 542px;
  top: 745px;
  background: url(/images/crawlercolor.svg);
}
</style>
